<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
            <div class="mu-d-flex mu-justify-content-between mu-align-items-center mu-flex-wrap">
                <section class="mu-d-flex ">
                    <h1 class="mu-mb-00">Process instance</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">
                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>
                <section>

                    <div role="group" class="mcc-button-group mcc-button-group--spaced" id="instanceViewHeadersButtons">
                        <button class="mcc-button mcc-button--outline" id="exportAsPDFBtn" title="Export as PDF" @click="exportAsPDF()">
                            <mcc-icon name="export" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Export as PDF</span>
                        </button>
                        <button @click="$refs.processDetailsdialogRef.show()" type="button" class="mcc-button mcc-button--outline" id="processDetails" title="Process details" dialog="processDetails-dialog">
                            <mcc-icon name="info" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Process details</span>
                        </button>
                        <button @click="$refs.terminateProcConfDialogRef.show()" class="mcc-button mcc-button--danger" v-if="!isCompleted && isAdmin" id="terminateInstance" title="Terminate process" dialog="terminateProcConfDialog">
                            <mcc-icon name="unavailable" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Terminate process</span>
                        </button>

                    </div>

                </section>
            </div>
        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <div class="mcc-row" v-if="!fetchCall">
            <div class="mcc-col colSpinner">
                <div class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb">
                <li v-if="menu=='all'">Process engine</li>
                <li v-if="menu!='all'">My processes</li>
                <li v-if="menu=='all'">
                    <a class="table-link" @click="redirectToList()">Instances</a>
                </li>
                <li v-if="menu=='startedbyme'">
                    <a class="table-link" @click="redirectToList()">Started by me</a>
                </li>
                <li v-if="menu=='involvingme'">
                    <a class="table-link" @click="redirectToList()">All involved</a>
                </li>
                <li>{{processInfo.name}} ({{processInstanceId}})</li>
            </ol>
        </nav>
        <div class="mcc-card">
            <div class="mcc-card__body">

                <div class="mcc-row" v-show="fetchCall">
                    <div class="mcc-col">
                        <div class="mcc-card">
                            <div class="mcc-card__header">
                                <h2 class="mcc-card__title">Diagram</h2>
                            </div>
                            <div class="mcc-card__body">
                                <div id="oldSvgContainer" v-html="image" name="modelImage" class="modelImageOverflow"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mcc-row" v-show="fetchCall">
                    <div class="mcc-col">
                        <div class="mcc-card mu-mt-05">
                            <div class="mcc-card__body">
                                <div class="mcc-tabs mcc-tabs--compact mcc-tabs--pill">
                                    <input type="radio" id="taskTab" name="Process-instanceTab" checked="">
                                    <input type="radio" id="Process-variablesTab" name="Process-instanceTab">
                                    <input type="radio" id="Process-errorsTab" name="Process-instanceTab">
                                    <ul role="tablist" class="mu-mb-05">
                                        <li role="tab">
                                            <label for="taskTab" tabindex="0">
                                                <span>Tasks</span>
                                            </label>
                                        </li>
                                        <li role="tab">
                                            <label for="Process-variablesTab" tabindex="0">
                                                <span>Process variables</span>
                                            </label>
                                        </li>
                                        <li role="tab">
                                            <label for="Process-errorsTab" tabindex="0">
                                                <span>Process errors</span>
                                            </label>
                                        </li>
                                    </ul>
                                    <div role="tabpanel">
                                        <div style="position:relative">

                                            <mcc-data-table ref="taskListsTable" id="taskListsTableRef"></mcc-data-table>
                                        </div>
                                    </div>
                                    <div role="tabpanel">
                                        <mcc-data-table id="processVariableTable"></mcc-data-table>
                                    </div>
                                    <div role="tabpanel">
                                        <div style="position:relative">
                                            <mcc-data-table ref="processErrorsTable" id="processErrorsTableId"></mcc-data-table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--info mcc-dialog--xs" id="processDetails-dialog" ref="processDetailsdialogRef">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Process details</h2> <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.processDetailsdialogRef.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>

                </div>
                <div class="mcc-dialog__body">
                    <div class="mcc-row">
                        <div class="mcc-col">
                            <div class="processContainer">
                                <div class="mcc-row">
                                    <div class="mcc-col">
                                        <mcc-alert role="alert" class="mcc-alert mcc-alert--info mcc-alert--compact">
                                            <mcc-icon name="info_popup" aria-hidden="true" icon-set="fluency-filled"></mcc-icon>
                                            <div>
                                                <span class="mu-fw-semi-bold"> {{ ` Started by ${startUserId} - ${startTime} ` }}</span>
                                            </div>
                                            <div v-if="endTime != null">
                                                <span class="mu-fw-semi-bold"> {{ `Completed - ${endTime} ` }}</span>
                                            </div>
                                            <div v-if="durationInMillis != null">
                                                <span class="mu-fw-semi-bold"> {{ `Completed in ${durationInMillis} ` }}</span>
                                            </div>
                                        </mcc-alert>
                                    </div>
                                </div>
                                <div v-for="(obj, index) in processDetails" :key="index" class="mu-my-03">
                                    <div class="mcc-row">
                                        <div class="mcc-col">
                                            <span>{{obj.key}}</span>
                                        </div>
                                        <div class="mcc-col">

                                            <span>{{obj.value}}</span>
                                        </div>
                                    </div>
                                    <div class="seperator mu-mt-03" v-if="index != processDetails.length -1"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mcc-dialog__footer">
                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--info" id="processDetailsDialogBtn" @click="$refs.processDetailsdialogRef.close()">Close</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--warning mcc-dialog--xs" v-if="!isCompleted && isAdmin" color="warning" id="terminateProcConfDialog" ref="terminateProcConfDialogRef">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Terminate process</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.terminateProcConfDialogRef.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <div class="mcc-row">
                        <div class="mcc-col">
                            Are you sure you want to terminate this process instance?
                        </div>
                    </div>
                </div>
                <div class="mcc-dialog__footer">

                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" id="noTerminateProcBtn" class="mcc-button mcc-button--outline" @click="$refs.terminateProcConfDialogRef.close()">No</button>
                        <button type="button" id="yesTerminateProcBtn" class="mcc-button mcc-button--warning" @click="handleTerminateProcDialogClose($event)">Yes</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--info mcc-dialog--xs" ref="processFailureDetailDialog" id="processFailureDetailDialog">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Process failure details</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.processFailureDetailDialog.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <div ref="detailedErrorMessage" id="detailedErrorMessage" v-html="errorDetail"></div>
                </div>
                <div class="mcc-dialog__footer">
                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="submit" id="closeProcessFailureBtn" class="mcc-button mcc-button--info" @click="closeprocessFailureDetailDialog()">Close</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--danger  mcc-dialog--xs" ref="deleteEntityModal" id="deleteEntityModal">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Delete error</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.deleteEntityModal.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <div class="mcc-row">
                        <div class="mcc-col">
                            {{removeProcessErrorMsg}}?
                        </div>
                    </div>
                </div>
                <div class="mcc-dialog__footer">
                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--outline" id="noDeletebtn" @click="$refs.deleteEntityModal.close()">No</button>
                        <button type="button" class="mcc-button mcc-button--danger" id="yesDeletebtn" @click="closeDelErrDialog($event)">Yes</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
</div>
</template>

<script>
import InstanceAPI from "../../../services/InstanceAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import ProcessErrorAPI from "../../../services/ProcessErrorAPI";
import Utils from "../../../script_utils";

export default {
    name: "InstanceView",
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["processengine.instances.view"],
            dataLoaded: false,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            fetchCall: false,
            updateCallTasks: false,
            updateCallProcess: false,
            image: "",
            processVariables: {},
            startUserId: "",
            startTime: "",
            endTime: "",
            durationInMillis: "",
            taskDefKey: "",
            isCompleted: "",
            isAdmin: "",
            processInstanceId: "",
            processInfo: "",
            taskListsTable: null,
            processErrorTable: null,
            processDetails: [],
            errorDetail: "",
            removeProcessErrorMsg: "",
            removeProcessErrorId: "",
            tableData: [],
            filterActive: false,
            filterData: [],
            menu: this.$route.params.menu,
            errorFilterData: [],
            errorTableData: [],
            errorFilterActive: false

        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        let self = this;
        InstanceAPI.getInstanceDetails(this.$route.params.instId, this.menu)
            .then(result => {
                if (result == null) {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching instance details"
                    });
                    self.redirectToList();
                    return;
                }
                self.dataLoaded = true;
                self.image = result.image;
                self.processVariables = result.processVariables;
                self.startUserId = result.startUserId != null ? result.startUserId : 'SYSTEM';
                self.startTime = Utils.getMomentDateString(result.startTime);
                self.endTime = Utils.getMomentDateString(result.endTime);
                self.durationInMillis = result.durationInMillis;
                self.taskDefKey = result.taskDefKey;
                self.isCompleted = result.isCompleted;
                self.isAdmin = result.isAdmin;
                self.processInstanceId = result.processInstanceId;
                self.processInfo = result.processInfo;

                let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.processes.instances"];
                pageTitle += " - " + self.processInfo.name;
                EventBus.$emit("update-pageTitle", pageTitle);
            })
            .finally(() => {
                if (self.dataLoaded) {
                    self.fetchCall = true;
                    self.afterDataLoaded();
                }
                self.initTasksTable();
                self.initProcessVariablesTable(self.processVariables)
                self.initProcessErrorsTable()
            });
    },
    watch: {
        'taskObj.image'() {
            this.$nextTick(() => {
                this.setViewBoxForSVG();
            });
        }
    },
    methods: {
        setViewBoxForSVG() {
            const svgElement = this.$el.querySelector('#oldSvgContainer svg');
            if (svgElement) {
                const bbox = svgElement.getBBox();
                svgElement.setAttribute('viewBox', `${bbox.x} ${bbox.y} ${bbox.width} ${bbox.height}`);
            }
        },
        async afterDataLoaded() {
            await this.$nextTick();
            this.processDetailShowHandler();
            this.loadTables();
            this.updateSVG();
        },
        handleShowErrorDetail() {
            let self = this;
            setTimeout(() => {
                $(self.$refs.detailedErrorMessage).jsonFormatter();
            }, 0);
        },
        closeprocessFailureDetailDialog() {
            this.$refs.processFailureDetailDialog.close()
            this.errorDetail = ""
        },
        getFilterCount() {
            if (this.selectedLabelRef != "")
                this.filterCount += 1;
            if (this.applicationNameRef != "")
                this.filterCount += 1;
            if (this.deployedRef != "")
                this.filterCount += 1;
            if (this.disabledRef != "")
                this.filterCount += 1;
            if (this.protectedRef != "")
                this.filterCount += 1;
        },
        filterTable(e) {
            this.filterCount = 0;
            this.getFilterCount();
            this.selectedLabels = this.selectedLabelRef;
            this.applicationName = this.applicationNameRef;
            this.deployedType = this.deployedRef;
            this.disabledType = this.disabledRef;
            this.protectedType = this.protectedRef;
            this.initApplicationsTable();
        },
        updateOrderList(filteredApplicationList) {
            this.filterData = filteredApplicationList;
            this.filterActive = true;
            this.initTasksTable();
        },
        updateFilterPVTable(filteredApplicationList) {
            this.initProcessVariablesTable(filteredApplicationList);
        },
        updateErrorFilterTable(filteredApplicationList) {
            this.errorFilterData = filteredApplicationList
            this.errorFilterActive = true
            this.initProcessErrorsTable();
        },
        filterErrorFunctionList(filteredRows, filterValue) {
            return filteredRows.filter(function (f) {
                return (
                    f.processName.toString().toLowerCase().includes(filterValue.toLowerCase()) ||
                    f.taskName.toLowerCase().includes(filterValue.toLowerCase())
                );
            })
        },
        filterFunctionList(filteredRows, filterValue) {
            return filteredRows.filter(function (f) {
                return (
                    f.name.toString().toLowerCase().includes(filterValue.toLowerCase()) ||
                    f.assignee.toLowerCase().includes(filterValue.toLowerCase())
                );
            })
        },
        filterFunctionProcessVariables(filteredRows, filterValue) {
            return filteredRows.filter(function (f) {
                return (
                    f.name && f.name.toLowerCase().includes(filterValue.toLowerCase()) ||
                    f.variableType.typeName && f.variableType.typeName.toLowerCase().includes(filterValue.toLowerCase()) ||
                    f.cachedValue && f.cachedValue.toLowerCase().includes(filterValue.toLowerCase()) ||
                    f.scopeType && f.scopeType.toLowerCase().includes(filterValue.toLowerCase())

                );
            })
        },
        closeDelErrDialog(e) {
            let self = this;
            self.$refs.deleteEntityModal.close()
            ProcessErrorAPI.removeProcessError(this.removeProcessErrorId).then(result => {
                self.initProcessErrorsTable();
                EventBus.$emit('success-notification', {
                    "msg": constantMessages.MESSAGES["processerror.delete.success"]
                });
            });
        },
        handleTerminateProcDialogClose(e) {
            let self = this;
            self.$refs.terminateProcConfDialogRef.close()
            InstanceAPI.terminateProcessInstance(self.processInstanceId).then(response => {
                if (response != null && response.error == false) {
                    if (response.error) {
                        EventBus.$emit("error-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                    } else {
                        EventBus.$emit("success-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                        self.redirectToList();
                    }
                }
            });
        },
        processDetailShowHandler() {
            this.processDetails = [{
                    'key': 'Name',
                    'value': this.processInfo.name
                },
                {
                    'key': 'Description',
                    'value': this.processInfo.description
                },
                {
                    'key': 'Category',
                    'value': this.processInfo.category
                },
            ];
        },
        updateSVG() {
            let self = this;
            setTimeout(() => {
                Utils.updateSVG("oldSvgContainer");
            }, 0);

            InstanceAPI.getActivities(this.$route.params.instId)
                .then(data => {
                    for (let i in data) {
                        if (data[i].activityType != "exclusiveGateway" &&
                            data[i].activityType != "sequenceFlow") {
                            $("[data-id=" + data[i].activityId + "]").css({
                                stroke: "#009a44"
                            });
                            $("[data-id=" + data[i].activityId + "]").css(
                                "stroke-width", "5px");
                        }
                    }
                    if (self.taskDefKey) {
                        $("[data-id=" + self.taskDefKey + "]").css({
                            stroke: "#1d428a"
                        });
                        $("[data-id=" + self.taskDefKey + "]").css("stroke-width", "5px");
                    }
                });
        },
        loadTables() {
            let self = this;
            self.initTasksTable();
            self.initProcessVariablesTable(self.processVariables)
            self.initProcessErrorsTable();
        },
        initProcessVariablesTable(processVariableList) {
            let self = this;
            const filesTable = document.querySelector('#processVariableTable');
            window.tableFactory.create(filesTable, {
                bordered: true,
                striped: true,
                columnSearch: false,
                pageSize: 10,
                totalCount: processVariableList.length,
                schema: {
                    properties: {
                        name: {
                            type: "string",
                            title: "Name",
                            sortable: true,
                            columnSearch: false
                        },
                        typeName: {
                            type: "string",
                            title: "Type",
                            sortable: true,
                            columnSearch: false
                        },
                        cachedValue: {
                            type: "string",
                            title: "Value",
                            sortable: true,
                            columnSearch: false
                        },
                        scopeType: {
                            type: "string",
                            title: "Scope",
                            sortable: true,
                            columnSearch: false
                        },

                    }
                },
                data: function (start, limit) {
                    for (let i = 0; i < processVariableList.length; i++) {
                        processVariableList[i].typeName = processVariableList[i].variableType.typeName;
                    }
                    return processVariableList;
                }

            });

        },
        initTasksTable() {
            let self = this;
            if (self.currentPageSize == null) {
                self.currentPageSize = 10;
            }
            const filesTable = document.querySelector('#taskListsTableRef');
            this.taskListsTable = window.tableFactory.create(filesTable, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No tasks found</p>',
                columnSearch: false,
                pageSize: self.currentPageSize,
                debounceTime: 1000,
                schema: {
                    properties: {
                        name: {
                            type: "string",
                            title: "Name",
                            template: '<div class="taskName d-none" data-id="{{id}}">{{name}}<div>',
                            sortable: true,
                            columnSearch: false
                        },
                        assignee: {
                            type: "string",
                            title: "Assignee",
                            sortable: true,
                            columnSearch: false
                        },
                        owner: {
                            type: "string",
                            title: "Owner",
                            sortable: true,
                            columnSearch: false
                        },
                        prettyStartTime: {
                            type: "string",
                            title: "Created",
                            sortable: true,
                            template: '<div class="dateTemplate"><u>{{prettyStartTime}}</u><div>{{createdDateString}}</div></div>',
                            columnSearch: false
                        },
                        prettyDueDate: {
                            type: "string",
                            title: "Due",
                            sortable: true,
                            template: '<div class="dateTemplate"><u>{{prettyDueDate}}</u><div>{{dueDateObjectString}}</div></div>',
                            columnSearch: false
                        },
                        prettyClaimTime: {
                            type: "string",
                            title: "Claimed",
                            template: '<div class="dateTemplate"><u>{{prettyClaimTime}}</u><div>{{claimedDateString}}</div></div>',
                            sortable: false,
                            columnSearch: false
                        },
                        prettyEndTime: {
                            type: "string",
                            title: "Completed",
                            template: '<div class="dateTemplate"><u>{{prettyEndTime}}</u><div>{{completedDateString}}</div></div>',
                            sortable: true,
                            columnSearch: false
                        },
                        prettyDurationInMillis: {
                            type: "string",
                            title: "Duration",
                            template: '<div class="dateTemplate"><u>{{prettyDurationInMillis}}</u><div>{{durationInMillis}}</div></div>',
                            sortable: true,
                            columnSearch: false
                        },
                        priority: {
                            type: "string",
                            title: "Priority",
                            sortable: true,
                            columnSearch: false
                        },
                        prettyWorkTimeInMillis: {
                            type: "string",
                            title: "Work time",
                            template: '<div class="dateTemplate"><u>{{prettyWorkTimeInMillis}}</u><div>{{workTimeInMillis}}</div></div>',
                            sortable: false,
                            columnSearch: false
                        }
                    }
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    if (!self.filterActive) {
                        self.updateCallTasks = false;
                        if (self.taskListsTable != null) {
                            self.currentPageSize =
                                self.taskListsTable.tableContext.store.state.pageSize;
                        }
                        let sortHeaderData = sortHeader == null ? "" : sortHeader;
                        let sortDir = sortDirection == null ? "" : sortDirection;
                        if (sortHeaderData == "prettyStartTime") {
                            sortHeaderData = "startTime";
                        } else if (sortHeaderData == "prettyEndTime") {
                            sortHeaderData = "endTime";
                        } else if (sortHeaderData == "prettyDurationInMillis") {
                            sortHeaderData = "duration";
                        } else if (sortHeaderData == "prettyDueDate") {
                            sortHeaderData = "dueDate";
                        } else if (sortHeaderData == "prettyCreateTime") {
                            sortHeaderData = "createTime";
                        }
                        let queryString =
                            "start=" +
                            start +
                            "&length=" +
                            self.currentPageSize +
                            "&sort=" +
                            sortHeaderData +
                            "&dir=" +
                            sortDir +
                            "&processInstanceId=" +
                            self.processInstanceId +
                            "&involvingAll=false&withoutVariable=true&filterInput=true";
                        return InstanceAPI.getAllTasks(queryString, self.menu, []).then(result => {
                            let responseData = {
                                totalCount: 0,
                                data: []
                            };
                            responseData.totalCount = result.page.totalElements;
                            result.data.forEach(item => {
                                item['createdDateString'] = item['createdDate'] != null ? Utils.getMomentDateString(item['createdDate']) : ''
                                item['dueDateObjectString'] = item['dueDateObject'] != null ? Utils.getMomentDateString(item['dueDateObject']) : ''
                                item['claimedDateString'] = item['claimedDate'] != null ? Utils.getMomentDateString(item['claimedDate']) : ''
                                item['completedDateString'] = item['completedDate'] != null ? Utils.getMomentDateString(item['completedDate']) : ''
                                item['durationInMillis'] = item['durationInMillis'] != null ? item['durationInMillis'] + ' ms' : '';
                                item['workTimeInMillis'] = item['workTimeInMillis'] != null ? item['workTimeInMillis'] + ' ms' : '';
                            });
                            responseData.data = result.data;
                            self.tableData = responseData.data;
                            self.updateCallTasks = true;
                            return responseData;
                        });
                    } else {
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        return responseData;
                    }
                },
                onAfterDataLoad: (start, limit) => {
                    self.updateTemplateForTasks();
                }
            });
        },
        updateTemplateForTasks() {
            let self = this;
            $(".taskName").each((a, obj) => {
                let name = $(obj)
                    .text();
                let id = $(obj).attr("data-id");
                let htmlTag = "";
                if (self.isAdmin) {
                    htmlTag += '<a class="name-link" data-id="' + id + '">' + name + "</a>";
                } else {
                    htmlTag += '<span>' + name + '</span>'
                }
                $(obj).html(htmlTag);
                $(obj).removeClass("d-none");
            });
            this.$refs.taskListsTable
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null) {
                            let reference = $(targetEle).attr("data-id");
                            self.$router.push(
                                self.CONTEXT_PATH + "/processengine/tasks/" + reference.trim()
                            );
                        }
                    });
                });
        },
        initProcessErrorsTable() {
            let self = this;
            self.updateCallProcess = false;
            if (this.processErrorTable != null) {
                this.currentPageSize = this.processErrorTable.tableContext.store.state.pageSize;
            }
            const filesTable = document.querySelector('#processErrorsTableId');
            this.processErrorTable = window.tableFactory.create(filesTable, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No process errors found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.currentPageSize,
                debounceTime: 1000,
                schema: {
                    properties: {
                        processName: {
                            type: "string",
                            title: "Process name",
                            sortable: false,
                            columnSearch: false
                        },
                        taskName: {
                            type: "string",
                            title: "Task",
                            sortable: false,
                            columnSearch: false
                        },
                        createdTime: {
                            type: "string",
                            title: "Created",
                            template: '<div class="dateTemplate"><u>{{createdTime}}</u><div>{{createdDateString}}</div></div>',
                            sortable: false,
                            columnSearch: false
                        },
                        actions: {
                            type: "object",
                            title: "Actions",
                            properties: {
                                viewErrorAction: {
                                    type: "string",
                                    format: "button",
                                    title: "View error",
                                    icon: "view",
                                    color: "success",
                                    iconOnly: false
                                },
                                deleteAction: {
                                    type: "string",
                                    format: "button",
                                    title: "Delete",
                                    icon: "trash",
                                    color: "danger",
                                    iconOnly: true
                                }
                            }
                        }
                    }
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    if (!self.errorFilterActive) {
                        self.updateCallProcess = false;
                        if (self.processErrorTable != null) {
                            self.currentPageSize = self.processErrorTable.tableContext.store.state.pageSize;
                        }
                        let queryString =
                            "start=" +
                            start +
                            "&length=" +
                            limit +
                            "&processInstanceId=" +
                            self.processInstanceId;
                        return InstanceAPI.getProcessErrorsForInstance(queryString).then(result => {
                            let responseData = {
                                totalCount: 0,
                                data: []
                            };
                            responseData.totalCount = result.page.totalElements;
                            if (result.data != null) {
                                result.data.forEach(element => {
                                    element['createdDateString'] = element['created'] != null ?
                                        Utils.getMomentDateString(element['created']) : ''
                                });
                                responseData.data = result.data;
                                self.errorTableData = responseData.data;
                            }
                            self.updateCallProcess = true;
                            return responseData;
                        });
                    } else {
                        self.errorFilterActive = false;
                        let responseData = {
                            totalCount: self.errorFilterData.length,
                            data: self.errorFilterData
                        };
                        return responseData;
                    }
                },
                onAction: (table, action, obj) => {
                    let rowData = obj[0].rowData;
                    if (action == "viewErrorAction") {
                        self.errorDetail = "";
                        self.errorDetail = rowData.errorMessage;
                        self.$refs.processFailureDetailDialog.show();
                        self.handleShowErrorDetail()
                    } else if (action == "deleteAction") {
                        self.removeProcessErrorMsg = "";
                        self.removeProcessErrorId = "";
                        if (rowData.processName != null && rowData.processName != "") {
                            self.removeProcessErrorMsg = "Are you sure you want to remove error : " + rowData.processName;
                        } else {
                            self.removeProcessErrorMsg = "Are you sure you want to remove error";
                        }
                        self.removeProcessErrorId = rowData.id;
                        self.$refs.deleteEntityModal.show();
                    }
                },
                onAfterDataLoad: (start, limit) => {}
            });
        },
        exportAsPDF() {
            return InstanceAPI.exportAsPDF(this.processInstanceId, this.menu);
        },
        redirectToList() {
            if (this.menu == 'all') {
                localStorage.setItem("instanceList", "instanceList");
                this.$router.push(
                    this.CONTEXT_PATH + '/processengine/processes'
                );
            } else {
                localStorage.setItem(this.menu + "Processes", this.menu);
                this.$router.push(
                    this.CONTEXT_PATH + '/processes/' + this.menu
                );
            }
        },
    }
};
</script>
    
<style scoped>
@import "../../../assets/css/symbol.css";
</style><style scoped>
.modelImageOverflow {
    overflow-x: auto;
}

.taskItem {
    border-bottom: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
    padding: 10px !important;
}

.taskItem div:last-child {
    flex-basis: 70%;
    text-align: right;
}

#detailedErrorMessage {
    max-height: 400px;
    overflow: auto;
}
</style>
